module.exports = __webpack_public_path__ + "static/feynman-db439a7658399c99a66a77870a9bf8e6.png";